/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />


module Meevo.Components.Controls {
    'use strict';

    export class MeevoColumnSort implements angular.IDirective {
        restrict = 'E';
        scope = {
            class: '@?',
            isShowSortControls: '=?',
            showArrows: '=?',
            isShowUpperArrow: '=?',
            isShowLowerArrow: '=?',

        };
        template = `
            <div class="{{ class }}" layout="row" ng-if="isShowSortControls">
                <md-icon ng-show="showArrows || isShowUpperArrow"
                            md-svg-icon="assets/images/icons/walkin_arrowup.svg"></md-icon>
                <md-icon ng-show="showArrows || isShowLowerArrow"
                            md-svg-icon="assets/images/icons/walkin_arrowdown.svg"></md-icon>
            </div>`;

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            if (typeof scope.isShowSortControls === 'undefined') {
                scope.isShowSortControls = true;
            }
        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoColumnSort();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.egifts')
        .directive('meevoColumnSort', MeevoColumnSort.factory());
}